import type { ValidationErrors, WebcastData } from './event-details';

import i18next from 'i18next';

export const MAX_NAME_LENGTH = 100;
export const MAX_TITLE_LENGTH = 200;

export function eventDetailsValidation(values: WebcastData) {
  const errors: ValidationErrors = {};

  if (!values.name.trim()) {
    errors.name = i18next.t('translations:manager.webcastSetup.eventDetails.name.validation.required');
  } else if (values.name.trim().length > MAX_NAME_LENGTH) {
    errors.name = i18next.t('translations:manager.webcastSetup.eventDetails.name.validation.tooLong', {
      maxNameLength: MAX_NAME_LENGTH,
    });
  }

  if (!values.durationInMinutes) {
    errors.durationInMinutes = i18next.t('translations:manager.webcastSetup.eventDetails.duration.validation.required');
  }

  if (!values.startingHour) {
    errors.startingHour = i18next.t('translations:manager.webcastSetup.eventDetails.time.hour.validation.required');
  }

  if (!values.startingMinutes) {
    errors.startingMinutes = i18next.t(
      'translations:manager.webcastSetup.eventDetails.time.minutes.validation.required'
    );
  }

  return errors;
}
